<form [formGroup]="formGroup">
  <div class="form-section">
    <div class="row">
      <mat-form-field class="field">
        <mat-label>Contact</mat-label>
        <input matInput
          formControlName="contact">
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>Email</mat-label>
        <input matInput
          formControlName="email">
        @if (formGroup.get('email').hasError('email')) {
          <mat-error>
            Must be a valid email.
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="field">
        <mat-label>Address 1</mat-label>
        <input matInput
          required
          formControlName="address1">
        @if (formGroup.get('address1').hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>Address 2</mat-label>
        <input matInput
          formControlName="address2">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="field">
        <mat-label>City</mat-label>
        <input matInput
          required
          formControlName="city">
        @if (formGroup.get('city').hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>State</mat-label>
        <input matInput
          required
          maxlength="2"
          formControlName="state">
        @if (formGroup.get('state').hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>Postal Code</mat-label>
        <input matInput
          required
          formControlName="postalCode">
        @if (formGroup.get('postalCode').hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field class="field">
        <mat-label>Country</mat-label>
        <mat-select required
          formControlName="country">
          @for (country of countryOptions; track $index) {
            <mat-option
              [value]="country">
              {{country}}
            </mat-option>
          }
        </mat-select>
        @if (formGroup.get('country').hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>Phone</mat-label>
        @if (!maskPhone) {
          <input
            matInput
            type="tel"
            required
            formControlName="phone">
        }
        @if (maskPhone) {
          <input
            matInput
            hqPhoneMask
            type="tel"
            required
            formControlName="phone">
        }
        @if (formGroup.get('phone').hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
        @if (maskPhone) {
          <mat-hint>
            Numbers only: (000) 000-0000
          </mat-hint>
        }
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>Fax</mat-label>
        <input matInput
          type="tel"
          formControlName="fax">
      </mat-form-field>
    </div>
  </div>
</form>
